// extracted by mini-css-extract-plugin
export default {"wrapper":"MainLayout_wrapper__lY68z","container":"MainLayout_container__+ai7M"};